import React from "react";

export const directions = [
  {
    id: 1,
    title: "Бакалавриат и специалитет",
    description: "18 программ",
    imageUrl: "path-to-image",
    link: "#bachelor",
  },
  {
    id: 2,
    title: "Магистратура",
    description: "13 программ",
    imageUrl: "path-to-image",
    link: "#magistr",
  },
  {
    id: 3,
    title: "Аспирантура",
    description: "3 программы",
    imageUrl: "path-to-image",
    link: "#Aspirant",
  },
  {
    id: 4,
    title: "Колледж",
    description: "13 программ",
    imageUrl: "path-to-image",
    link: "#colledge",
  },
  {
    id: 5,
    title: "Повышение квалификации",
    description: "45 программ",
    imageUrl: "path-to-image",
    link: "#dpo",
  },
  {
    id: 6,
    title: "Подготовительные курсы",
    description: "10 программ",
    imageUrl: "path-to-image",
    link: "#course",
  },
];

// Бакалавр очно бюджет
export const events = [


  // Бакалавриат

  {
    "title": "Подача документов",
    "start": new Date(2025, 5, 20),
    "end": new Date(2025, 6, 25),
    "color": "#3291a8",
    "desc": "срок подачи документов для поступающих на бюджетные места (ЕГЭ)",
    "educationLevel": 2,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Ранжированные списки",
    "start": new Date(2025, 6, 27),
    "end": new Date(2025, 6, 28),
    "color": "#3291a8",
    "desc": "публикация ранжированных списков на сайте",
    "educationLevel": 2,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Крайняя дата согласия на зачисление",
    "start": new Date(2025, 7, 1),
    "end": new Date(2025, 7, 2),
    "color": "#3291a8",
    "desc": "крайняя дата представления согласия на зачисление (квота)",
    "educationLevel": 2,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Крайняя дата согласия на зачисление",
    "start": new Date(2025, 7, 5),
    "end": new Date(2025, 7, 6),
    "color": "#3291a8",
    "desc": "крайняя дата представления согласия на зачисление (основной этап)",
    "educationLevel": 2,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Издание приказа о зачислении",
    "start": new Date(2025, 7, 3),
    "end": new Date(2025, 7, 4),
    "color": "#3291a8",
    "desc": "издание приказа о зачислении (квота)",
    "educationLevel": 2,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Издание приказа о зачислении",
    "start": new Date(2025, 7, 7),
    "end": new Date(2025, 7, 8),
    "color": "#3291a8",
    "desc": "издание приказа о зачислении (основной этап)",
    "educationLevel": 2,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Подача документов",
    "start": new Date(2025, 5, 20),
    "end": new Date(2025, 6, 20),
    "color": "#3291a8",
    "desc": "срок подачи документов для поступающих на бюджетные места (ЕГЭ и вступительные испытания ГГУ)",
    "educationLevel": 2,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Вступительные испытания",
    "start": new Date(2025, 6, 18),
    "end": new Date(2025, 6, 25),
    "color": "#3291a8",
    "desc": "проведение вступительных испытаний",
    "educationLevel": 2,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Подача документов",
    "start": new Date(2025, 5, 20),
    "end": new Date(2025, 6, 25),
    "color": "#3291a8",
    "desc": "срок подачи документов для дополнительного зачисления на бюджетные места (ЕГЭ)",
    "educationLevel": 2,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Ранжированные списки",
    "start": new Date(2025, 6, 27),
    "end": new Date(2025, 6, 28),
    "color": "#3291a8",
    "desc": "публикация ранжированных списков на сайте",
    "educationLevel": 2,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Крайняя дата согласия на зачисление",
    "start": new Date(2025, 7, 9),
    "end": new Date(2025, 7, 10),
    "color": "#3291a8",
    "desc": "крайняя дата представления согласия на зачисление (основной этап)",
    "educationLevel": 2,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Издание приказа о зачислении",
    "start": new Date(2025, 7, 11),
    "end": new Date(2025, 7, 12),
    "color": "#3291a8",
    "desc": "издание приказа о зачислении (основной этап)",
    "educationLevel": 2,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Подача документов",
    "start": new Date(2025, 7, 12),
    "end": new Date(2025, 7, 21),
    "color": "#3291a8",
    "desc": "срок подачи документов для дополнительного приема на бюджетные места (ЕГЭ и вступительные испытания ГГУ)",
    "educationLevel": 2,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Вступительные испытания",
    "start": new Date(2025, 7, 14),
    "end": new Date(2025, 7, 21),
    "color": "#3291a8",
    "desc": "проведение вступительных испытаний",
    "educationLevel": 2,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Ранжированные списки",
    "start": new Date(2025, 7, 22),
    "end": new Date(2025, 7, 23),
    "color": "#3291a8",
    "desc": "публикация ранжированных списков на сайте",
    "educationLevel": 2,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Крайняя дата согласия на зачисление",
    "start": new Date(2025, 7, 25),
    "end": new Date(2025, 7, 26),
    "color": "#3291a8",
    "desc": "крайняя дата представления согласия на зачисление (квота)",
    "educationLevel": 2,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Крайняя дата согласия на зачисление",
    "start": new Date(2025, 7, 28),
    "end": new Date(2025, 7, 29),
    "color": "#3291a8",
    "desc": "крайняя дата представления согласия на зачисление (основной этап)",
    "educationLevel": 2,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Издание приказа о зачислении",
    "start": new Date(2025, 7, 26),
    "end": new Date(2025, 7, 27),
    "color": "#3291a8",
    "desc": "издание приказа о зачислении (квота)",
    "educationLevel": 2,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Издание приказа о зачислении",
    "start": new Date(2025, 7, 29),
    "end": new Date(2025, 7, 30),
    "color": "#3291a8",
    "desc": "издание приказа о зачислении (основной этап)",
    "educationLevel": 2,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Подача документов",
    "start": new Date(2025, 5, 20),
    "end": new Date(2025, 7, 20),
    "color": "#3291a8",
    "desc": "срок подачи документов для внебюджетных мест (ЕГЭ)",
    "educationLevel": 2,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Ранжированные списки",
    "start": new Date(2025, 7, 22),
    "end": new Date(2025, 7, 23),
    "color": "#3291a8",
    "desc": "публикация ранжированных списков на сайте",
    "educationLevel": 2,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Крайняя дата согласия на зачисление",
    "start": new Date(2025, 7, 26),
    "end": new Date(2025, 7, 27),
    "color": "#3291a8",
    "desc": "крайняя дата представления согласия на зачисление",
    "educationLevel": 2,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Издание приказа о зачислении",
    "start": new Date(2025, 7, 30),
    "end": new Date(2025, 7, 31),
    "color": "#3291a8",
    "desc": "издание приказа о зачислении",
    "educationLevel": 2,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Подача документов",
    "start": new Date(2025, 5, 20),
    "end": new Date(2025, 7, 20),
    "color": "#3291a8",
    "desc": "срок подачи документов для внебюджетных мест (ЕГЭ и вступительные испытания ГГУ)",
    "educationLevel": 2,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Вступительные испытания",
    "start": new Date(2025, 9, 11),
    "end": new Date(2025, 9, 19),
    "color": "#3291a8",
    "desc": "проведение вступительных испытаний",
    "educationLevel": 2,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Ранжированные списки",
    "start": new Date(2025, 9, 22),
    "end": new Date(2025, 9, 23),
    "color": "#3291a8",
    "desc": "публикация ранжированных списков на сайте",
    "educationLevel": 2,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Крайняя дата согласия на зачисление",
    "start": new Date(2025, 9, 26),
    "end": new Date(2025, 9, 27),
    "color": "#3291a8",
    "desc": "крайняя дата представления согласия на зачисление",
    "educationLevel": 2,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Издание приказа о зачислении",
    "start": new Date(2025, 9, 30),
    "end": new Date(2025, 9, 31),
    "color": "#3291a8",
    "desc": "издание приказа о зачислении",
    "educationLevel": 2,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Подача документов",
    "start": new Date(2025, 5, 20),
    "end": new Date(2025, 10, 10),
    "color": "#3291a8",
    "desc": "срок подачи документов для внебюджетных мест (дополнительный прием, очная форма)",
    "educationLevel": 2,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Вступительные испытания",
    "start": new Date(2025, 9, 13),
    "end": new Date(2025, 9, 20),
    "color": "#3291a8",
    "desc": "проведение вступительных испытаний",
    "educationLevel": 2,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Ранжированные списки",
    "start": new Date(2025, 9, 22),
    "end": new Date(2025, 9, 23),
    "color": "#3291a8",
    "desc": "публикация ранжированных списков на сайте",
    "educationLevel": 2,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Крайняя дата согласия на зачисление",
    "start": new Date(2025, 9, 27),
    "end": new Date(2025, 9, 28),
    "color": "#3291a8",
    "desc": "крайняя дата представления согласия на зачисление",
    "educationLevel": 2,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Издание приказа о зачислении",
    "start": new Date(2025, 9, 31),
    "end": new Date(2025, 10, 1),
    "color": "#3291a8",
    "desc": "издание приказа о зачислении",
    "educationLevel": 2,
    "execForm": 1,
    "finance": 2
  },
  //СПЕЦИАЛИТЕТ
  {
    "title": "Подача документов",
    "start": new Date(2025, 5, 20),
    "end": new Date(2025, 6, 25),
    "color": "#3291a8",
    "desc": "срок подачи документов для бюджетных мест (ЕГЭ)",
    "educationLevel": 1,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Ранжированные списки",
    "start": new Date(2025, 6, 27),
    "end": new Date(2025, 6, 28),
    "color": "#3291a8",
    "desc": "публикация ранжированных списков на сайте",
    "educationLevel": 1,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Крайняя дата согласия на зачисление",
    "start": new Date(2025, 7, 1),
    "end": new Date(2025, 7, 2),
    "color": "#3291a8",
    "desc": "крайняя дата представления согласия на зачисление (квота)",
    "educationLevel": 1,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Крайняя дата согласия на зачисление",
    "start": new Date(2025, 7, 5),
    "end": new Date(2025, 7, 6),
    "color": "#3291a8",
    "desc": "крайняя дата представления согласия на зачисление (основной этап)",
    "educationLevel": 1,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Издание приказа о зачислении",
    "start": new Date(2025, 7, 3),
    "end": new Date(2025, 7, 4),
    "color": "#3291a8",
    "desc": "издание приказа о зачислении (квота)",
    "educationLevel": 1,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Издание приказа о зачислении",
    "start": new Date(2025, 7, 7),
    "end": new Date(2025, 7, 8),
    "color": "#3291a8",
    "desc": "издание приказа о зачислении (основной этап)",
    "educationLevel": 1,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Подача документов",
    "start": new Date(2025, 5, 20),
    "end": new Date(2025, 6, 20),
    "color": "#3291a8",
    "desc": "срок подачи документов для бюджетных мест (ЕГЭ и вступительные испытания ГГУ)",
    "educationLevel": 1,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Вступительные испытания",
    "start": new Date(2025, 6, 18),
    "end": new Date(2025, 6, 25),
    "color": "#3291a8",
    "desc": "проведение вступительных испытаний",
    "educationLevel": 1,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Ранжированные списки",
    "start": new Date(2025, 6, 27),
    "end": new Date(2025, 6, 28),
    "color": "#3291a8",
    "desc": "публикация ранжированных списков на сайте",
    "educationLevel": 1,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Крайняя дата согласия на зачисление",
    "start": new Date(2025, 7, 1),
    "end": new Date(2025, 7, 2),
    "color": "#3291a8",
    "desc": "крайняя дата представления согласия на зачисление (квота)",
    "educationLevel": 1,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Крайняя дата согласия на зачисление",
    "start": new Date(2025, 7, 5),
    "end": new Date(2025, 7, 6),
    "color": "#3291a8",
    "desc": "крайняя дата представления согласия на зачисление (основной этап)",
    "educationLevel": 1,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Издание приказа о зачислении",
    "start": new Date(2025, 7, 3),
    "end": new Date(2025, 7, 4),
    "color": "#3291a8",
    "desc": "издание приказа о зачислении (квота)",
    "educationLevel": 1,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Издание приказа о зачислении",
    "start": new Date(2025, 7, 7),
    "end": new Date(2025, 7, 8),
    "color": "#3291a8",
    "desc": "издание приказа о зачислении (основной этап)",
    "educationLevel": 1,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Подача документов",
    "start": new Date(2025, 5, 20),
    "end": new Date(2025, 6, 25),
    "color": "#3291a8",
    "desc": "срок подачи документов для дополнительного зачисления на бюджетные места (ЕГЭ)",
    "educationLevel": 1,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Ранжированные списки",
    "start": new Date(2025, 6, 27),
    "end": new Date(2025, 6, 28),
    "color": "#3291a8",
    "desc": "публикация ранжированных списков на сайте",
    "educationLevel": 1,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Крайняя дата согласия на зачисление",
    "start": new Date(2025, 7, 9),
    "end": new Date(2025, 7, 10),
    "color": "#3291a8",
    "desc": "крайняя дата представления согласия на зачисление (основной этап)",
    "educationLevel": 1,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Издание приказа о зачислении",
    "start": new Date(2025, 7, 11),
    "end": new Date(2025, 7, 12),
    "color": "#3291a8",
    "desc": "издание приказа о зачислении (основной этап)",
    "educationLevel": 1,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Подача документов",
    "start": new Date(2025, 7, 12),
    "end": new Date(2025, 7, 21),
    "color": "#3291a8",
    "desc": "срок подачи документов для дополнительного приема на бюджетные места (ЕГЭ)",
    "educationLevel": 1,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Ранжированные списки",
    "start": new Date(2025, 7, 22),
    "end": new Date(2025, 7, 23),
    "color": "#3291a8",
    "desc": "публикация ранжированных списков на сайте",
    "educationLevel": 1,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Крайняя дата согласия на зачисление",
    "start": new Date(2025, 7, 25),
    "end": new Date(2025, 7, 26),
    "color": "#3291a8",
    "desc": "крайняя дата представления согласия на зачисление (квота)",
    "educationLevel": 1,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Крайняя дата согласия на зачисление",
    "start": new Date(2025, 7, 28),
    "end": new Date(2025, 7, 29),
    "color": "#3291a8",
    "desc": "крайняя дата представления согласия на зачисление (основной этап)",
    "educationLevel": 1,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Издание приказа о зачислении",
    "start": new Date(2025, 7, 26),
    "end": new Date(2025, 7, 27),
    "color": "#3291a8",
    "desc": "издание приказа о зачислении (квота)",
    "educationLevel": 1,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Издание приказа о зачислении",
    "start": new Date(2025, 7, 29),
    "end": new Date(2025, 7, 30),
    "color": "#3291a8",
    "desc": "издание приказа о зачислении (основной этап)",
    "educationLevel": 1,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Подача документов",
    "start": new Date(2025, 5, 20),
    "end": new Date(2025, 7, 20),
    "color": "#3291a8",
    "desc": "срок подачи документов для внебюджетных мест (ЕГЭ)",
    "educationLevel": 1,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Ранжированные списки",
    "start": new Date(2025, 7, 22),
    "end": new Date(2025, 7, 23),
    "color": "#3291a8",
    "desc": "публикация ранжированных списков на сайте",
    "educationLevel": 1,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Крайняя дата согласия на зачисление",
    "start": new Date(2025, 7, 26),
    "end": new Date(2025, 7, 27),
    "color": "#3291a8",
    "desc": "крайняя дата представления согласия на зачисление",
    "educationLevel": 1,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Издание приказа о зачислении",
    "start": new Date(2025, 7, 30),
    "end": new Date(2025, 7, 31),
    "color": "#3291a8",
    "desc": "издание приказа о зачислении",
    "educationLevel": 1,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Подача документов",
    "start": new Date(2025, 5, 20),
    "end": new Date(2025, 7, 20),
    "color": "#3291a8",
    "desc": "срок подачи документов для внебюджетных мест (ЕГЭ и вступительные испытания ГГУ)",
    "educationLevel": 1,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Вступительные испытания",
    "start": new Date(2025, 7, 11),
    "end": new Date(2025, 7, 19),
    "color": "#3291a8",
    "desc": "проведение вступительных испытаний",
    "educationLevel": 1,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Ранжированные списки",
    "start": new Date(2025, 7, 22),
    "end": new Date(2025, 7, 23),
    "color": "#3291a8",
    "desc": "публикация ранжированных списков на сайте",
    "educationLevel": 1,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Крайняя дата согласия на зачисление",
    "start": new Date(2025, 7, 26),
    "end": new Date(2025, 7, 27),
    "color": "#3291a8",
    "desc": "крайняя дата представления согласия на зачисление",
    "educationLevel": 1,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Издание приказа о зачислении",
    "start": new Date(2025, 7, 30),
    "end": new Date(2025, 7, 31),
    "color": "#3291a8",
    "desc": "издание приказа о зачислении",
    "educationLevel": 1,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Подача документов",
    "start": new Date(2025, 5, 20),
    "end": new Date(2025, 10, 10),
    "color": "#3291a8",
    "desc": "срок подачи документов для внебюджетных мест (дополнительный прием, очная форма)",
    "educationLevel": 1,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Вступительные испытания",
    "start": new Date(2025, 9, 13),
    "end": new Date(2025, 9, 20),
    "color": "#3291a8",
    "desc": "проведение вступительных испытаний",
    "educationLevel": 1,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Ранжированные списки",
    "start": new Date(2025, 9, 22),
    "end": new Date(2025, 9, 23),
    "color": "#3291a8",
    "desc": "публикация ранжированных списков на сайте",
    "educationLevel": 1,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Крайняя дата согласия на зачисление",
    "start": new Date(2025, 9, 27),
    "end": new Date(2025, 9, 28),
    "color": "#3291a8",
    "desc": "крайняя дата представления согласия на зачисление",
    "educationLevel": 1,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Издание приказа о зачислении",
    "start": new Date(2025, 9, 31),
    "end": new Date(2025, 10, 1),
    "color": "#3291a8",
    "desc": "издание приказа о зачислении",
    "educationLevel": 1,
    "execForm": 1,
    "finance": 2
  },
  //МАГИСТРАТУРА
  {
    "title": "Подача документов",
    "start": new Date(2025, 5, 20),
    "end": new Date(2025, 7, 20),
    "color": "#3291a8",
    "desc": "срок подачи документов для бюджетных мест",
    "educationLevel": 3,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Вступительные испытания",
    "start": new Date(2025, 7, 12),
    "end": new Date(2025, 7, 21),
    "color": "#3291a8",
    "desc": "проведение вступительных испытаний",
    "educationLevel": 3,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Ранжированные списки",
    "start": new Date(2025, 7, 22),
    "end": new Date(2025, 7, 23),
    "color": "#3291a8",
    "desc": "публикация ранжированных списков на сайте",
    "educationLevel": 3,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Крайняя дата согласия на зачисление",
    "start": new Date(2025, 7, 24),
    "end": new Date(2025, 7, 25),
    "color": "#3291a8",
    "desc": "крайняя дата представления согласия на зачисление",
    "educationLevel": 3,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Издание приказа о зачислении",
    "start": new Date(2025, 7, 29),
    "end": new Date(2025, 7, 30),
    "color": "#3291a8",
    "desc": "издание приказа о зачислении",
    "educationLevel": 3,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Подача документов",
    "start": new Date(2025, 5, 20),
    "end": new Date(2025, 7, 20),
    "color": "#3291a8",
    "desc": "срок подачи документов для бюджетных мест (дополнительное зачисление)",
    "educationLevel": 3,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Вступительные испытания",
    "start": new Date(2025, 7, 12),
    "end": new Date(2025, 7, 21),
    "color": "#3291a8",
    "desc": "проведение вступительных испытаний",
    "educationLevel": 3,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Ранжированные списки",
    "start": new Date(2025, 7, 22),
    "end": new Date(2025, 7, 23),
    "color": "#3291a8",
    "desc": "публикация ранжированных списков на сайте",
    "educationLevel": 3,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Крайняя дата согласия на зачисление",
    "start": new Date(2025, 7, 26),
    "end": new Date(2025, 7, 27),
    "color": "#3291a8",
    "desc": "крайняя дата представления согласия на зачисление",
    "educationLevel": 3,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Издание приказа о зачислении",
    "start": new Date(2025, 7, 29),
    "end": new Date(2025, 7, 30),
    "color": "#3291a8",
    "desc": "издание приказа о зачислении",
    "educationLevel": 3,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Подача документов",
    "start": new Date(2025, 7, 31),
    "end": new Date(2025, 8, 10),
    "color": "#3291a8",
    "desc": "срок подачи документов для бюджетных мест (дополнительный прием)",
    "educationLevel": 3,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Вступительные испытания",
    "start": new Date(2025, 8, 11),
    "end": new Date(2025, 8, 13),
    "color": "#3291a8",
    "desc": "проведение вступительных испытаний",
    "educationLevel": 3,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Ранжированные списки",
    "start": new Date(2025, 8, 14),
    "end": new Date(2025, 8, 15),
    "color": "#3291a8",
    "desc": "публикация ранжированных списков на сайте",
    "educationLevel": 3,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Крайняя дата согласия на зачисление",
    "start": new Date(2025, 8, 15),
    "end": new Date(2025, 8, 16),
    "color": "#3291a8",
    "desc": "крайняя дата представления согласия на зачисление",
    "educationLevel": 3,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Издание приказа о зачислении",
    "start": new Date(2025, 8, 20),
    "end": new Date(2025, 8, 21),
    "color": "#3291a8",
    "desc": "издание приказа о зачислении",
    "educationLevel": 3,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Подача документов",
    "start": new Date(2025, 5, 20),
    "end": new Date(2025, 10, 10),
    "color": "#3291a8",
    "desc": "срок подачи документов для внебюджетных мест (дополнительный прием, очно-заочная и заочная формы)",
    "educationLevel": 3,
    "execForm": 2,
    "finance": 2
  },
  {
    "title": "Вступительные испытания",
    "start": new Date(2025, 10, 11),
    "end": new Date(2025, 10, 19),
    "color": "#3291a8",
    "desc": "проведение вступительных испытаний",
    "educationLevel": 3,
    "execForm": 2,
    "finance": 2
  },
  {
    "title": "Ранжированные списки",
    "start": new Date(2025, 10, 22),
    "end": new Date(2025, 10, 23),
    "color": "#3291a8",
    "desc": "публикация ранжированных списков на сайте",
    "educationLevel": 3,
    "execForm": 2,
    "finance": 2
  },
  {
    "title": "Крайняя дата согласия на зачисление",
    "start": new Date(2025, 10, 26),
    "end": new Date(2025, 10, 27),
    "color": "#3291a8",
    "desc": "крайняя дата представления согласия на зачисление",
    "educationLevel": 3,
    "execForm": 2,
    "finance": 2
  },
  {
    "title": "Издание приказа о зачислении",
    "start": new Date(2025, 10, 30),
    "end": new Date(2025, 10, 31),
    "color": "#3291a8",
    "desc": "издание приказа о зачислении",
    "educationLevel": 3,
    "execForm": 2,
    "finance": 2
  },
  {
    "title": "Подача документов",
    "start": new Date(2025, 5, 20),
    "end": new Date(2025, 9, 10),
    "color": "#3291a8",
    "desc": "срок подачи документов для внебюджетных мест (дополнительный прием, очная форма)",
    "educationLevel": 3,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Вступительные испытания",
    "start": new Date(2025, 9, 13),
    "end": new Date(2025, 9, 20),
    "color": "#3291a8",
    "desc": "проведение вступительных испытаний",
    "educationLevel": 3,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Ранжированные списки",
    "start": new Date(2025, 9, 22),
    "end": new Date(2025, 9, 23),
    "color": "#3291a8",
    "desc": "публикация ранжированных списков на сайте",
    "educationLevel": 3,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Крайняя дата согласия на зачисление",
    "start": new Date(2025, 9, 27),
    "end": new Date(2025, 9, 28),
    "color": "#3291a8",
    "desc": "крайняя дата представления согласия на зачисление",
    "educationLevel": 3,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Издание приказа о зачислении",
    "start": new Date(2025, 9, 31),
    "end": new Date(2025, 10, 1),
    "color": "#3291a8",
    "desc": "издание приказа о зачислении",
    "educationLevel": 3,
    "execForm": 1,
    "finance": 2
  },
  //КОЛЛЕДЖ
  {
    "title": "Подача документов",
    "start": new Date(2024, 8, 1),
    "end": new Date(2024, 8, 22),
    "color": "#3291a8",
    "desc": "срок подачи документов для дополнительного приема (I этап)",
    "educationLevel": 4,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Вступительные испытания",
    "start": new Date(2024, 8, 23),
    "end": new Date(2024, 8, 24),
    "color": "#3291a8",
    "desc": "проведение вступительных испытаний (I этап)",
    "educationLevel": 4,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Ранжированные списки",
    "start": new Date(2024, 8, 25),
    "end": new Date(2024, 8, 26),
    "color": "#3291a8",
    "desc": "публикация ранжированных списков на сайте (I этап)",
    "educationLevel": 4,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Крайняя дата оплаты за обучение",
    "start": new Date(2024, 8, 27),
    "end": new Date(2024, 8, 28),
    "color": "#3291a8",
    "desc": "крайняя дата внесения оплаты за обучение (I этап)",
    "educationLevel": 4,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Издание приказа о зачислении",
    "start": new Date(2024, 8, 30),
    "end": new Date(2024, 8, 31),
    "color": "#3291a8",
    "desc": "издание приказа о зачислении (I этап)",
    "educationLevel": 4,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Подача документов",
    "start": new Date(2024, 9, 1),
    "end": new Date(2024, 9, 24),
    "color": "#3291a8",
    "desc": "срок подачи документов для дополнительного приема (II этап)",
    "educationLevel": 4,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Вступительные испытания",
    "start": new Date(2024, 9, 25),
    "end": new Date(2024, 9, 26),
    "color": "#3291a8",
    "desc": "проведение вступительных испытаний (II этап)",
    "educationLevel": 4,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Ранжированные списки",
    "start": new Date(2024, 9, 26),
    "end": new Date(2024, 9, 27),
    "color": "#3291a8",
    "desc": "публикация ранжированных списков на сайте (II этап)",
    "educationLevel": 4,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Крайняя дата оплаты за обучение",
    "start": new Date(2024, 9, 29),
    "end": new Date(2024, 9, 30),
    "color": "#3291a8",
    "desc": "крайняя дата внесения оплаты за обучение (II этап)",
    "educationLevel": 4,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Издание приказа о зачислении",
    "start": new Date(2024, 9, 31),
    "end": new Date(2024, 10, 1),
    "color": "#3291a8",
    "desc": "издание приказа о зачислении (II этап)",
    "educationLevel": 4,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Подача документов",
    "start": new Date(2024, 10, 1),
    "end": new Date(2024, 10, 24),
    "color": "#3291a8",
    "desc": "срок подачи документов для дополнительного приема (III этап)",
    "educationLevel": 4,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Вступительные испытания",
    "start": new Date(2024, 10, 25),
    "end": new Date(2024, 10, 26),
    "color": "#3291a8",
    "desc": "проведение вступительных испытаний (III этап)",
    "educationLevel": 4,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Ранжированные списки",
    "start": new Date(2024, 10, 26),
    "end": new Date(2024, 10, 27),
    "color": "#3291a8",
    "desc": "публикация ранжированных списков на сайте (III этап)",
    "educationLevel": 4,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Крайняя дата оплаты за обучение",
    "start": new Date(2024, 10, 27),
    "end": new Date(2024, 10, 28),
    "color": "#3291a8",
    "desc": "крайняя дата внесения оплаты за обучение (III этап)",
    "educationLevel": 4,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Издание приказа о зачислении",
    "start": new Date(2024, 10, 29),
    "end": new Date(2024, 10, 30),
    "color": "#3291a8",
    "desc": "издание приказа о зачислении (III этап)",
    "educationLevel": 4,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Подача документов",
    "start": new Date(2024, 5, 20),
    "end": new Date(2024, 7, 10),
    "color": "#3291a8",
    "desc": "срок подачи документов для очной формы обучения (первый поток)",
    "educationLevel": 4,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Вступительные испытания",
    "start": new Date(2024, 7, 11),
    "end": new Date(2024, 7, 15),
    "color": "#3291a8",
    "desc": "проведение вступительных испытаний (первый поток)",
    "educationLevel": 4,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Ранжированные списки",
    "start": new Date(2024, 7, 19),
    "end": new Date(2024, 7, 20),
    "color": "#3291a8",
    "desc": "публикация ранжированных списков на сайте (первый поток)",
    "educationLevel": 4,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Крайняя дата оплаты за обучение / предоставление оригинала документа об образовании",
    "start": new Date(2024, 7, 23),
    "end": new Date(2024, 7, 24),
    "color": "#3291a8",
    "desc": "крайняя дата внесения оплаты за обучение / предоставления оригинала документа об образовании (первый поток)",
    "educationLevel": 4,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Издание приказа о зачислении",
    "start": new Date(2024, 7, 25),
    "end": new Date(2024, 7, 30),
    "color": "#3291a8",
    "desc": "издание приказа о зачислении (первый поток)",
    "educationLevel": 4,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Подача документов",
    "start": new Date(2024, 5, 20),
    "end": new Date(2024, 7, 15),
    "color": "#3291a8",
    "desc": "срок подачи документов для очной формы обучения (без экзаменов)",
    "educationLevel": 4,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Ранжированные списки",
    "start": new Date(2024, 7, 19),
    "end": new Date(2024, 7, 20),
    "color": "#3291a8",
    "desc": "публикация ранжированных списков на сайте (без экзаменов)",
    "educationLevel": 4,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Крайняя дата оплаты за обучение / предоставление оригинала документа об образовании",
    "start": new Date(2024, 7, 23),
    "end": new Date(2024, 7, 24),
    "color": "#3291a8",
    "desc": "крайняя дата внесения оплаты за обучение / предоставления оригинала документа об образовании (без экзаменов)",
    "educationLevel": 4,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Издание приказа о зачислении",
    "start": new Date(2024, 7, 25),
    "end": new Date(2024, 7, 30),
    "color": "#3291a8",
    "desc": "издание приказа о зачислении (без экзаменов)",
    "educationLevel": 4,
    "execForm": 1,
    "finance": 1
  },
  {
    "title": "Подача документов",
    "start": new Date(2024, 5, 20),
    "end": new Date(2024, 7, 10),
    "color": "#3291a8",
    "desc": "срок подачи документов для заочной формы обучения",
    "educationLevel": 4,
    "execForm": 3,
    "finance": 2
  },
  {
    "title": "Вступительные испытания",
    "start": new Date(2024, 7, 11),
    "end": new Date(2024, 7, 15),
    "color": "#3291a8",
    "desc": "проведение вступительных испытаний (заочная форма)",
    "educationLevel": 4,
    "execForm": 3,
    "finance": 2
  },
  {
    "title": "Ранжированные списки",
    "start": new Date(2024, 7, 22),
    "end": new Date(2024, 7, 23),
    "color": "#3291a8",
    "desc": "публикация ранжированных списков на сайте (заочная форма)",
    "educationLevel": 4,
    "execForm": 3,
    "finance": 2
  },
  {
    "title": "Крайняя дата оплаты за обучение",
    "start": new Date(2024, 7, 26),
    "end": new Date(2024, 7, 27),
    "color": "#3291a8",
    "desc": "крайняя дата внесения оплаты за обучение (заочная форма)",
    "educationLevel": 4,
    "execForm": 3,
    "finance": 2
  },
  {
    "title": "Издание приказа о зачислении",
    "start": new Date(2024, 7, 30),
    "end": new Date(2024, 7, 31),
    "color": "#3291a8",
    "desc": "издание приказа о зачислении (заочная форма)",
    "educationLevel": 4,
    "execForm": 3,
    "finance": 2
  },
  //АСПИРАНТУРА
  {
    "title": "Подача документов",
    "start": new Date(2024, 9, 1),
    "end": new Date(2024, 9, 22),
    "color": "#3291a8",
    "desc": "срок подачи документов для мест с оплатой по договорам (первый этап)",
    "educationLevel": 7,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Вступительные испытания",
    "start": new Date(2024, 9, 23),
    "end": new Date(2024, 9, 24),
    "color": "#3291a8",
    "desc": "проведение вступительных испытаний (первый этап)",
    "educationLevel": 7,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Ранжированные списки",
    "start": new Date(2024, 9, 26),
    "end": new Date(2024, 9, 27),
    "color": "#3291a8",
    "desc": "публикация ранжированных списков на сайте (первый этап)",
    "educationLevel": 7,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Крайняя дата оплаты за обучение",
    "start": new Date(2024, 9, 29),
    "end": new Date(2024, 9, 30),
    "color": "#3291a8",
    "desc": "крайняя дата внесения оплаты за обучение (первый этап)",
    "educationLevel": 7,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Издание приказа о зачислении",
    "start": new Date(2024, 9, 31),
    "end": new Date(2024, 10, 1),
    "color": "#3291a8",
    "desc": "издание приказа о зачислении (первый этап)",
    "educationLevel": 7,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Подача документов",
    "start": new Date(2024, 10, 1),
    "end": new Date(2024, 10, 24),
    "color": "#3291a8",
    "desc": "срок подачи документов для мест с оплатой по договорам (второй этап)",
    "educationLevel": 7,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Вступительные испытания",
    "start": new Date(2024, 10, 25),
    "end": new Date(2024, 10, 26),
    "color": "#3291a8",
    "desc": "проведение вступительных испытаний (второй этап)",
    "educationLevel": 7,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Ранжированные списки",
    "start": new Date(2024, 10, 26),
    "end": new Date(2024, 10, 27),
    "color": "#3291a8",
    "desc": "публикация ранжированных списков на сайте (второй этап)",
    "educationLevel": 7,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Крайняя дата оплаты за обучение",
    "start": new Date(2024, 10, 27),
    "end": new Date(2024, 10, 28),
    "color": "#3291a8",
    "desc": "крайняя дата внесения оплаты за обучение (второй этап)",
    "educationLevel": 7,
    "execForm": 1,
    "finance": 2
  },
  {
    "title": "Издание приказа о зачислении",
    "start": new Date(2024, 10, 29),
    "end": new Date(2024, 10, 30),
    "color": "#3291a8",
    "desc": "издание приказа о зачислении (второй этап)",
    "educationLevel": 7,
    "execForm": 1,
    "finance": 2
  }

];

export const CostData = [
  {
    name: "Педагогическое образование",
    execForm: "",
    cost: "",
    subRows: [
      {
        name: "Физическая культура",
        execForm: "очная",
        cost: "40 000",
      },
      {
        name: "Дошкольное образование",
        execForm: "заочная",
        cost: "40 000",
      },
    ],
  },
  {
    name: "Психолого-педагогическое образование",
    execForm: "",
    cost: "",
    subRows: [
      {
        name: "Психолого-педагогическое образование",
        execForm: "очная",
        cost: "40 000",
      },
      {
        name: "Психолого-педагогическое образование",
        execForm: "заочная",
        cost: "30 000",
      },
    ],
  },
  {
    name: "Дизайн",
    execForm: "",
    cost: "",
    subRows: [
      {
        name: "Дизайн",
        execForm: "очная",
        cost: "100 000",
      },
      {
        name: "Дизайн",
        execForm: "очно-заочная",
        cost: "30 000",
      },
    ],
  }
];

export const columns = [
  {
    accessorKey: "article",
    header: "Код",
    size: 80,
  },
  {
    accessorKey: "educationLevel",
    header: "Уровень образования",
    size: 150,
  },
  {
    accessorKey: "name",
    header: "Специальность",
    minSize: 300,
  },
  {
    accessorKey: "execFormName",
    header: "Форма обучения",
    size: 150,
  },
  {
    accessorKey: "price",
    header: "Стоимость",
    Cell: ({ cell }) => (
        <span>{(cell.getValue() || 0).toLocaleString("ru-RU")} ₽</span>
    ),
    size: 120,
  },
  {
    accessorKey: "paid",
    header: "Платных мест",
    size: 120,
  },
];
